import { ChangeDetectorRef, Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { MatSnackBar } from '@angular/material/snack-bar';
import { TranslateService } from '@ngx-translate/core';
import { ClipboardService } from 'ngx-clipboard';
import { IcalTokenService } from 'src/app/modules/alerts/services/ical-token.service';

export interface IcalSubscribeModalData {
  icalUrl: string | null;
}

@Component({
  selector: 'app-ical-subscribe-modal',
  templateUrl: './ical-subscribe-modal.component.html',
  styleUrls: ['./ical-subscribe-modal.component.scss'],
  standalone: false,
})
export class IcalSubscribeModalComponent implements OnInit {
  icalUrl: string | null = null;
  generating = false;

  constructor(
    public dialogRef: MatDialogRef<IcalSubscribeModalComponent, { icalUrl: string | null }>,
    @Inject(MAT_DIALOG_DATA) public data: IcalSubscribeModalData,
    private icalTokenService: IcalTokenService,
    private snackbar: MatSnackBar,
    private translate: TranslateService,
    private clipboard: ClipboardService,
    private ref: ChangeDetectorRef
  ) {}

  ngOnInit(): void {
    this.icalUrl = this.data?.icalUrl ?? null;
  }

  onGenerate(): void {
    this.generating = true;
    this.icalTokenService.generate().subscribe({
      next: (res) => {
        this.generating = false;
        if (res.url) {
          this.icalUrl = res.url;
        } else {
          this.snackbar.open(
            this.translate.instant('ALERTS.ONBOARDING.ERROR_GENERATE'),
            'Cerrar',
            { duration: 5000 }
          );
        }
        this.ref.markForCheck();
      },
      error: () => {
        this.generating = false;
        this.snackbar.open(
          this.translate.instant('ALERTS.ONBOARDING.ERROR_GENERATE'),
          'Cerrar',
          { duration: 5000 }
        );
        this.ref.markForCheck();
      },
    });
  }

  onCopy(): void {
    if (!this.icalUrl) return;
    this.clipboard.copyFromContent(this.icalUrl);
    this.snackbar.open(
      this.translate.instant('ALERTS.ONBOARDING.SNACK_COPIED'),
      'Cerrar',
      { duration: 2500 }
    );
  }

  onClose(): void {
    this.dialogRef.close({ icalUrl: this.icalUrl });
  }
}
